/**
 * 개발자(dev) 도메인 라우트 - 개발자 콘솔(관리자 전용 편의기능).
 * route name = OBJECT_ID -> pages/dev. meta.devTool = 운영사 전용 - 메뉴 카탈로그 밖 화면도 가드가 개발자 루트 보유로 판정한다.
 */
const routes = [
  {
    // 표준화면 빌더 - 검색+그리드 화면 조립·코드 생성 (개발자 > 개발자 도구, dev 서버 전용)
    path: 'dev/screen-builder',
    name: 'DEV0030',
    component: () => import('@/pages/dev/DEV0030.vue'),
    meta: {
      requiresAuth: true,
      devTool: true,
      title: '표준화면 빌더',
      menuId: 'DEV0030',
      objInfo: 'DEV0030 · 개발자/개발자도구 (관리자 전용 편의기능)',
    },
  },
  {
    // 양식관리 (win-report 통합 테스트) - @win/report 에디터/뷰어 목록·편집·작성 (개발자 > 개발자 도구)
    // lazy route 필수 - @win/report 번들 1.77MB(gzip 382kB)는 이 화면 진입 시에만 로드
    path: 'dev/report',
    name: 'DEV0040',
    component: () => import('@/pages/dev/DEV0040.vue'),
    meta: {
      requiresAuth: true,
      devTool: true,
      title: '양식관리 (win-report)',
      menuId: 'DEV0040',
      objInfo: 'DEV0040 · 개발자/개발자도구 (win-report G11 통합 테스트, 저장=localStorage — G12 에서 REST 교체)',
    },
  },
  {
    // 서식 발급·문서함 (실 REST) - win-report 동봉 서식 설치·작성·draft·발급·재열람 종단 (SignDocs 루프 #4)
    path: 'dev/forms',
    name: 'DEV0080',
    component: () => import('@/pages/dev/DEV0080.vue'),
    meta: {
      requiresAuth: true,
      devTool: true,
      title: '서식 발급·문서함 (REST)',
      menuId: 'DEV0080',
      objInfo: 'DEV0080 · 개발자/개발자도구 (서식 파이프라인 — formtmpl/formsubmit 실 REST)',
    },
  },
  {
    // 출퇴근 시뮬레이터 - 임의 사원으로 출퇴근 punch/cancel (개발자 > 개발자 도구, 관리자 전용)
    path: 'dev/attend-sim',
    name: 'DEV0050',
    component: () => import('@/pages/dev/DEV0050.vue'),
    meta: {
      requiresAuth: true,
      devTool: true,
      title: '출퇴근 시뮬레이터',
      menuId: 'DEV0050',
      objInfo: 'DEV0050 · 개발자/개발자도구 (관리자 전용 개발용 — 실 버튼 전 근태 데이터 생성)',
    },
  },
  {
    // 코드 관리 - 공통코드 그룹/코드값 CRUD (개발자 > 개발자 도구)
    path: 'dev/code',
    name: 'DEV0020',
    component: () => import('@/pages/dev/DEV0020.vue'),
    meta: {
      requiresAuth: true,
      devTool: true,
      title: '코드 관리',
      menuId: 'DEV0020',
      objInfo: 'DEV0020 · 개발자/개발자도구 (관리자 전용 편의기능)',
    },
  },
  {
    // 고객사 온보딩 - 템플릿 복제로 신규 테넌트 개설·해지 (개발자 > 개발자 도구)
    path: 'dev/tenant',
    name: 'DEV0090',
    component: () => import('@/pages/dev/DEV0090.vue'),
    meta: {
      requiresAuth: true,
      devTool: true,
      title: '고객사 온보딩',
      menuId: 'DEV0090',
      objInfo: 'DEV0090 · 개발자/개발자도구 (플랫폼 운영 테넌트 전용)',
    },
  },
];

export default routes;
